document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.carousel-cell').forEach(tile => {
    const backdrop = document.getElementById('product-hover-backdrop');

    const showTitle = () => {
      const title = tile.dataset.productTitle || tile.querySelector('.product-title')?.innerText;
      if (backdrop && title) {
        backdrop.textContent = title;
        backdrop.style.opacity = 0.08; // You can adjust this
      }
    };

    const hideTitle = () => {
      if (backdrop) {
        backdrop.style.opacity = 0;
      }
    };

    // Desktop hover
    tile.addEventListener('mouseenter', showTitle);
    tile.addEventListener('mouseleave', hideTitle);

    // Mobile touch
    tile.addEventListener('touchstart', showTitle, { passive: true });
    tile.addEventListener('touchend', hideTitle, { passive: true });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const flktyElement = document.querySelector('.js-flickity');
  const backdrop = document.getElementById('product-hover-backdrop');
  const isMobile = window.innerWidth <= 768;

  if (!flktyElement) return;

  // Destroy existing Flickity instance if needed
  const existingFlickity = Flickity.data(flktyElement);
  if (existingFlickity) {
    existingFlickity.destroy();
  }

  // Re-initialize Flickity with dynamic freeScroll
  const flkty = new Flickity(flktyElement, {
    prevNextButtons: true,
    pageDots: false,
    contain: true,
    cellAlign: 'left',
    freeScroll: !isMobile,
    groupCells: true,
    wrapAround: true,
    arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 45 }
  });
// Show first product title on load (mobile)
if (isMobile && backdrop) {
  const selectedCell = flkty.selectedElement;
  const initialTitle = selectedCell?.dataset.productTitle;
  if (initialTitle) {
    backdrop.textContent = initialTitle;
    backdrop.style.opacity = 0.1;
  }
}

  // Only add select listener on mobile for product-hover text
  if (isMobile && backdrop) {
    flkty.on('select', function () {
      const selectedCell = flkty.selectedElement;
      const title = selectedCell?.dataset.productTitle;
      if (title) {
        backdrop.textContent = title;
        backdrop.style.opacity = 0.1;
      }
    });
  }
});
